import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const RemoveButton = props => {
  const { emergencyContact, setModal, align } = props
  const handleClickRemove = () => {
    setModal({
      id: `confirmDeleteEmergencyContact${emergencyContact.id}`,
      open: true
    })
  }

  return (
    <ResponsiveButton onClick={handleClickRemove} align={align}>
      Remove
    </ResponsiveButton>
  )
}

export default RemoveButton
